import { IJob, jobMonitorControllerApi } from '@infa-service/mdp-orchestration-api';

import { AsyncPolling, AsyncPollingConfig } from '../../../utils/coreUtils';
export enum ExpandChildrenParams {
	'INPUT-PROPERTIES' = 'INPUT-PROPERTIES',
	'OUTPUT-PROPERTIES' = 'OUTPUT-PROPERTIES',
	'TASK-HIERARCHY' = 'TASK-HIERARCHY',
	'WORKFLOW-DETAILS' = 'WORKFLOW-DETAILS',
	'OPERATIONS' = 'OPERATIONS',
}
class JobStatusPolling extends AsyncPolling<IJob> {
	constructor(
		private jobId: string,
		config: AsyncPollingConfig<IJob>,
	) {
		super(config);
	}
	async poll() {
		const resp = await jobMonitorControllerApi.getJobRunDetails({
			jobId: this.jobId,
			expandChildren: [ExpandChildrenParams['TASK-HIERARCHY']],
		});
		return resp as IJob;
	}
}

export default JobStatusPolling;
